/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Leveling_Perm_Send_Messages_In_ThreadsInputs */



/**
* | output |
* | --- |
* | "Send Messages in Threads and Posts" |
*
* @param {Leveling_Perm_Send_Messages_In_ThreadsInputs} inputs
* @param {{ locale?: "en" | "ru" }} options
* @returns {LocalizedString}
*/
export const leveling_perm_send_messages_in_threads = /** @type {((inputs?: Leveling_Perm_Send_Messages_In_ThreadsInputs, options?: { locale?: "en" | "ru" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Leveling_Perm_Send_Messages_In_ThreadsInputs, { locale?: "en" | "ru" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "ru") return /** @type {LocalizedString} */ ("Отправлять сообщения в ветках и публикациях")
	return /** @type {LocalizedString} */ ("Send Messages in Threads and Posts")
});